<div class="objectLink-wrapper">
  <div t4-tooltip class="t4EntityLink">
    <span class="objectText">
      <a href="javascript: void(0)" (mouseenter)="show()" (mouseleave)="hide()" (click)="open()" (contextmenu)="onRightClick();$event.preventDefault();">
        <span #ref><ng-content></ng-content></span>
        <span *ngIf="ref.childNodes.length == 0">{{ displayText }}</span>
      </a>
    </span>

    <div #tooltipContent class="t4Tooltip-container">
      <div class="t4Tooltip-content row">
        <t4-objectInfo [object]="_object"></t4-objectInfo>
        @if(hasNfcTag){
        <span [matTooltip]="'Turbo.RentalObject.NfcTag' | translate : 'This trailer has been converted to self-service'">
          <mat-icon>lock</mat-icon>
          </span>
          }
      </div>
    </div>
  </div>

  @if(hasNfcTag) {
  <span [matTooltip]="'Turbo.RentalObject.NfcTag' | translate : 'This trailer has been converted to self-service'">
    <mat-icon>lock</mat-icon>
  </span>
  }
</div>

<mat-menu #menu="matMenu">
  <ng-template matMenuContent>
    <button mat-menu-item (click)="registerIssue()">
      <mat-icon>build</mat-icon>
      <span>{{ 'Turbo.FleetManager.Objects.mnuCreateRequest' | translate:'Register issue'}}</span>
    </button>
  </ng-template>
</mat-menu>
